import React, { Component, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../../components/styled-components/loader/loader";
import PhoneNumber from "../../components/form/components/Countrycode";
import { Button } from "../../components/button/Button";
import { InputGroup } from "../../components/inputGroup/InputGroup";
import Base64 from "../../utils/base64";
import { useDispatch, useSelector } from "react-redux";
import { postLoginId, postUserData } from "../../redux/slices/loginSlice";
import { Redirect } from "react-router-dom";
import "./Login.css";
import axios from "axios";
import ROUTES from "../../config/routes";
import swal from "sweetalert";
function Login() {
  const userLoginToken = localStorage.getItem("userLoginToken");

  const [token, setToken] = useState(userLoginToken);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  console.log("location in truteelogin", location);
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };

  const user = useSelector((state) => state.rootReducer.loginUser);
  const dispatch = useDispatch();

  const [username, setUserName] = useState(false);

  const [userData, setUserData] = useState({});

  const history = useHistory();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("here on key enter");
      loginSuccess();
    }
  };
  const handleLogin = async () => {
    console.log("key pressesddd...click");
    loginSuccess();
  };
  const loginSuccess = async () => {
    dispatch(postUserData(userData));

    try {
      setLoading(true);
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/signin`,
        userData,
        config
      );
      console.log("responsse of login", res.data.id);
      dispatch(postLoginId(res.data.id));
      setLoading(false);
      if (userData.hasOwnProperty("phone")) {
        console.log("location.state.from", location);
        if (location.state && location.state.from) {
          history.push({
            pathname: "/otpvalidation",
            state: { from: location.state.from },
            PathExact: location.PathExact,
          });
        } else {
          history.push("/otpvalidation");
        }
      }
    } catch (error) {
      setLoading(false);
      swal("Oops!", error.response.data.message, "error");
      console.log(error);
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <div className="login-card border">
        <h2 className="login-heading">Trusted Individual Login</h2>
        <div
          style={{
            color: "black",
            textAlign: "left",
            marginBottom: "1rem",
            fontFamily: "Poppins",
          }}
        > IFIDie.com is the portal site for those incredible individuals who have accepted
          the honor and responsibility of helping someone who has died. The Plan
          Creator may have asked multiple Trusted Individuals to help their
          loved ones following their death, but only one person can trigger the
          process to notify everyone. As a failsafe, the Plan Creator may have
          created a timer delay ranging from 4-48 hours, allowing them to stop
          the process. If someone is incapacitated - DO NOT start this process.
          <br />
          If the Plan Creator is in a hospital and you need access to their
          Advanced Health Care Directive (AHCD), that document is available for
          download on your access page if it is the wishes of the Plan Creator.
        </div>

        <div>
          <InputGroup>
            <label>Phone</label>
            <PhoneNumber
              id="phone"
              name="phone"
              onKeyPress={handleKeyPress}
              onChange={(e) => {
                if (username === true) {
                  console.log("not setting");
                } else {
                  setUserData({ phone: e.target.value });
                }
              }}
              size="large"
              placeholder="Phone"
            ></PhoneNumber>
          </InputGroup>

          <Button
            style={{ background: "#2A3DA3" }}
            onClick={() => {
              handleLogin();
            }}
            disabled={user.loading}
          >
            Login
          </Button>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <InputGroup>
              <label>
                Are You a Client?{" "}
                <dvi style={{ color: "rgb(57, 181, 74" }}>
                  <a href="/login" style={{ color: "#2A3DA3" }}>
                    Login here
                  </a>
                </dvi>
              </label>
            </InputGroup>
          </div>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
  );
}

export default Login;
